import { render, staticRenderFns } from "./GrapeFarmerNetwork.vue?vue&type=template&id=a68176b6&"
import script from "./GrapeFarmerNetwork.vue?vue&type=script&lang=js&"
export * from "./GrapeFarmerNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports